import { render, staticRenderFns } from "./QuoteTable.vue?vue&type=template&id=6b11ef97&scoped=true"
import script from "./QuoteTable.vue?vue&type=script&lang=ts"
export * from "./QuoteTable.vue?vue&type=script&lang=ts"
import style0 from "./QuoteTable.vue?vue&type=style&index=0&id=6b11ef97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b11ef97",
  null
  
)

export default component.exports